import { BadgeType } from "components/atoms/Badge/Badge";

const InvoiceStatusColors: Record<string, BadgeType> = {
  "Awaiting Audit": "warning",
  Approved: "primary",
  Declined: "danger",
  Unsubmitted: "secondary",
  Removed: "secondary",
};

export default InvoiceStatusColors;
